import FinancialsModule from '@/modules/financials/FinancialsModule';

export default FinancialsModule;
